import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import css from './Toast.module.scss';

import SuccessIcon from './img/success.component.svg';

interface IToastProps {
    text: string,
    delay: number,
    customEventName: string
}

export const Toast = ({ text, delay, customEventName }: IToastProps) => {
    const [isOpenned, setIsOpenned] = useState(false);

    const handleToggleToast = useCallback(
        () => {
            setIsOpenned((prev) => !prev);

            setTimeout(() => {
                setIsOpenned(false);
            }, delay);
        },
        [delay],
    );

    useEffect(
        () => {
            document.addEventListener(customEventName, handleToggleToast);
            return () => {
                document.removeEventListener(customEventName, handleToggleToast);
            };
        },
        [customEventName, handleToggleToast],
    );

    const rootClasses = classNames({
        [css.toastRoot]: true,
        [css.hidden]: !isOpenned,
    });

    return (
        <div className={rootClasses}>
            <SuccessIcon className={css.toastIcon} />
            <div className={css.toastText}>
                {text}
            </div>
        </div>
    );
};
